import { render, staticRenderFns } from "./bonusSetting.vue?vue&type=template&id=6642ac53&scoped=true&"
import script from "./bonusSetting.vue?vue&type=script&lang=js&"
export * from "./bonusSetting.vue?vue&type=script&lang=js&"
import style0 from "./bonusSetting.vue?vue&type=style&index=0&id=6642ac53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6642ac53",
  null
  
)

export default component.exports